/** @jsx jsx */
/** @jsxRuntime classic */

import { jsx } from '@emotion/react';
import React from 'react';
import { BaseInputProps } from '../shared-types';
import useTheme from '../style/useTheme';
import { getGetIdFn } from '../utils';

const getId = getGetIdFn('Label');

export type Props = Pick<BaseInputProps, 'label' | 'required'> & {
  htmlFor?: string;
  id?: string;
  cursor?: 'pointer';
  margin?: string;
};

const Label = ({
  label,
  required,
  htmlFor,
  id,
  cursor,
  margin,
}: Props): JSX.Element => {
  const { theme, resolveColor, resolveTypography } = useTheme();
  if (!label) return <React.Fragment />;

  return (
    <label
      id={id}
      data-testid={getId(label)}
      className="origami-Label"
      css={{
        ...resolveTypography('label'),
        display: 'flex',
        margin: margin ?? '8px 0',
        color: resolveColor(theme.components.input.label),
        cursor,
      }}
      htmlFor={htmlFor || getId(label)}
    >
      {label}
      {required ? ' *' : null}
    </label>
  );
};

export default Label;
